import { render, staticRenderFns } from "./IdeasAndUsers.vue?vue&type=template&id=6e6ce6ba"
import script from "./IdeasAndUsers.vue?vue&type=script&lang=js"
export * from "./IdeasAndUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6ce6ba')) {
      api.createRecord('6e6ce6ba', component.options)
    } else {
      api.reload('6e6ce6ba', component.options)
    }
    module.hot.accept("./IdeasAndUsers.vue?vue&type=template&id=6e6ce6ba", function () {
      api.rerender('6e6ce6ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/IdeasAndUsers.vue"
export default component.exports